/*******************************************************************************
  설  명 : 홈페이지 > 로그인 > 휴면회원 전환
  작성자 : 송영석
  작성일 : 2020-06-24
*******************************************************************************/
import { Component, OnInit, NgZone } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { ApiResponse } from '@app/service/api-response';
import { UtilService } from '@app/service/util.service';
import { CommonService } from '@app/service/common.service';
import { config } from '@app/service/config.service';

import { ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';

import { HMemberService } from '@home/service/member.service';

import { O2OZCMS } from '@app/components/o2oz-cms/o2oz-cms.component';

declare global {
  interface Window {
    fn: any;
  }
}

@Component({
  selector: 'app-member-dormant',
  templateUrl: './member-dormant.component.html',
  styleUrls: ['./member-dormant.component.scss']
})
export class MemberDormantComponent extends O2OZCMS implements OnInit {

  public authInfo: any = {};

  /*******************************************************************************
    설  명 : 생성자
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  constructor(
    router: Router,
    commonService: CommonService,
    activatedRoute: ActivatedRoute,
    toastrService: ToastrService,
    private ngZone: NgZone,
    private utilService: UtilService,
    private memberService: HMemberService
  ) {
    // 상위 클래스에 router 전달
    super(router, commonService, activatedRoute, toastrService);
  }

  /*******************************************************************************
    설  명 : 데이터 처리
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  ngOnInit(): void {
    this.memberInfo$.subscribe( data => {
      if ( typeof data['memNo'] === 'undefined' ) {
        this.router.navigate(['/member/login']);
        return false;
      }
    });

    window.fn  = window.fn || {};
    window.fn.namespace = window.fn.namespace || {};
    window.fn.namespace.hpAuthFunc = this.hpAuthFunc.bind(this);
    window.fn.namespace.ipinAuthFunc = this.ipinAuthFunc.bind(this);
  }

  /*******************************************************************************
    설  명 : 인증 실행 후 ngZone 실행
  *******************************************************************************/
  hpAuthFunc( response: any ) {
    this.ngZone.run(() => this.hpAuthCallback( response ));
  }

  ipinAuthFunc( response: any ) {
    this.ngZone.run(() => this.ipinAuthCallback( response ));
  }


  /*******************************************************************************
    설  명 : 본인인증 체크
  *******************************************************************************/
  authCheck( type: any ) {
    if ( type === 'H' ) {
      window.open( config.baseUrl + '/checkplus/checkplus_main.php', '', 'width=500,height=550,scrollbar=yes' );
      // this.hpAuthCallback('');
    } else if ( type === 'I' ) {
      window.open( config.baseUrl + '/ipin/ipin_request.php', '', 'width=500,height=550,scrollbar=yes' );
      // this.ipinAuthCallback('');
    } else {
      this.toastrService.error('정상적으로 실행하시기 바랍니다.', '');
    }
  }

  /*******************************************************************************
    설  명 : 휴대폰 인증 콜백
  *******************************************************************************/
  hpAuthCallback( response: any ) {
    this.authInfo = response;

    if ( this.authInfo !== null ) {

      this.memberService.setActiveMember().then( result => {
        if ( result.ResultCode === true ) {
          this.toastrService.success(result.ResultMessage);
          this.router.navigate(['/main']);
        } else {
          this.toastrService.error(result.ResultMessage);
        }
      });

    } else {
      this.toastrService.error('본인인증에 실패하였습니다.', '본인인증');
    }
  }

  /*******************************************************************************
    설  명 : 아이핀 인증 콜백
  *******************************************************************************/
  ipinAuthCallback( response: any ) {
    this.authInfo = response;

    if ( this.authInfo !== null ) {

      this.memberService.setActiveMember().then( result => {
        if ( result.ResultCode === true ) {
          this.toastrService.success(result.ResultMessage);
          this.router.navigate(['/main']);
        } else {
          this.toastrService.error(result.ResultMessage);
        }
      });

    } else {
      this.toastrService.error('본인인증에 실패하였습니다.', '본인인증');
    }
  }

}
